module.exports = __webpack_public_path__ + "media/images/blog-image-a2f6f0d79ec99189509730fa03e92eff.jpg";